import { render, staticRenderFns } from "./BananaModal.vue?vue&type=template&id=b6586e3e"
import script from "./BananaModal.vue?vue&type=script&setup=true&lang=js"
export * from "./BananaModal.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports